import Modal from "@mui/material/Modal";
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import Button from '../../../components/common/Button';
import { UserIcon } from '../Advisor/ClientIndex/Team';
import AnimatedPage from '../../../components/AnimatedPage';
import ProfileForm from '../../../components/Form/ProfileForm';
import BusinessCards, { hasValidAdvisor } from '../Advisor/BusinessCards';
import ProfileImageUploader from '../../../components/Form/ProfileImageUploader';
import TwoFactorAuthentication from '../../../components/Form/TwoFactoreAuthentication';

export const Profile = () => {

    const formRef = useRef();
    const userData = useSelector((state) => state.user);
    const company = useSelector((state) => state.company);

    const [selectedData, setSelectedData] = useState('');
    const [profileClass, setProfileClass] = useState("client-profile");

    return (
        <>
            <AnimatedPage>
                <div className="container py2rem df fdc pr">
                    {Object.keys(userData).length > 0 && <>
                        <div className='df jcsb aifs md-fdc user-profile-sec'>
                            <div className='w100'>
                                <div className='bg38 p2rem br20px sm1rem df fdc aic mt2rem jcfs w100 pr' style={{ borderRadius: '24px 24px 0 0' }}>
                                    {/* Profile Image Section */}
                                    <h2 className='c15 fw600 fs1-5rem'>User Profile</h2>
                                    {userData["role"] === "Advisor" &&
                                        <div className="pa" style={{ right: '1rem', top: '1rem' }}>
                                            <UserIcon
                                                onClick={() => setSelectedData({ ...userData })}
                                                color={hasValidAdvisor(userData) ? '#008000' : '#F44336'}
                                            />
                                        </div>
                                    }
                                    <ProfileImageUploader profileClass={profileClass} Button={Button} />
                                </div>
                                {/* Profile Form */}
                                <ProfileForm
                                    Button={Button}
                                    userData={userData}
                                    ref={formRef}
                                />

                                <TwoFactorAuthentication Button={Button} userData={userData} />
                            </div>
                            {/* Two Factor authentication */}

                        </div>
                    </>}
                </div>

                <Modal
                    open={Object.keys(selectedData).length}
                    onClose={() => setSelectedData({})}
                    className="td500 zi4 pf t0 l0 w100 h110vh df jcc aic"
                >
                    <BusinessCards
                        user={userData}
                        company={company}
                        selectedData={selectedData}
                        profileClass={profileClass}
                        setSelectedData={setSelectedData} />
                </Modal>
            </AnimatedPage>
        </>
    )
}

export default Profile